import { render, staticRenderFns } from "./ChartPower.vue?vue&type=template&id=2488941a&lang=pug&"
import script from "./ChartPower.vue?vue&type=script&lang=js&"
export * from "./ChartPower.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports